import { z } from "zod";
import { ActivitySchema } from "./Activity";

export const UpdateActivityRequestSchema = ActivitySchema.pick({
    name: true,
    description: true,
    ownerId: true,
    startDate: true,
    endDate: true
}).extend({
    accountId: z.number().positive().min(1),
});

export type UpdateActivityRequest = z.infer<typeof UpdateActivityRequestSchema>;